import { defineMessages, MessageDescriptor } from 'dibs-react-intl';
import { Locale, LOCALE_PSEUDO } from 'dibs-intl/exports/constants';

export const intlCountries: Record<
    Exclude<Locale, typeof LOCALE_PSEUDO>,
    MessageDescriptor
> = defineMessages({
    'en-US': {
        id: 'dbl.country.en-US',
        defaultMessage: 'English',
    },
    'en-GB': {
        id: 'dbl.country.en-GB',
        defaultMessage: 'English (UK)',
    },
    'fr-FR': {
        id: 'dbl.country.fr-FR',
        defaultMessage: 'French',
    },
    'de-DE': {
        id: 'dbl.country.de-DE',
        defaultMessage: 'German',
    },
});
